import React from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

export default function Loading() {
  return (
    <div className="loading" style={{ textAlign: "center" }}>
      LOADING
      <Loader type="Oval" color="#29c4ba" height={80} width={80} />
    </div>
  );
}
